// Outils partagés par le portail parent et le profil enseignant du soutien scolaire.

export const MODALITES = [["online", "En ligne"], ["home", "À domicile"], ["teacher_place", "Chez l'enseignant"]];
export const LIBELLE_MODALITE = Object.fromEntries(MODALITES);

export const JOURS = [["lundi", "Lundi"], ["mardi", "Mardi"], ["mercredi", "Mercredi"], ["jeudi", "Jeudi"],
  ["vendredi", "Vendredi"], ["samedi", "Samedi"], ["dimanche", "Dimanche"]];

export const STATUT_PROFIL = { draft: "Brouillon", pending: "En attente de validation", approved: "Approuvé", rejected: "Refusé", suspended: "Suspendu" };
export const STATUT_DEMANDE = { new: "En attente", contacting: "Prise de contact", confirmed: "Confirmée", completed: "Effectuée", cancelled: "Annulée" };

export const liste = (data) => (Array.isArray(data) ? data : (data?.results || []));

export const messageErreur = (erreur, defaut = "Une erreur est survenue.") => {
  const data = erreur?.response?.data;
  if (!erreur?.response) return "Connexion impossible. Vérifiez votre réseau puis réessayez.";
  if (typeof data?.detail === "string") return data.detail;
  const premier = data && typeof data === "object" ? Object.values(data).flat()[0] : null;
  return typeof premier === "string" ? premier : defaut;
};

export const initiales = (nom) => String(nom || "?").split(/\s+/).filter(Boolean).slice(0, 2).map((m) => m[0].toUpperCase()).join("");

export const fcfa = (montant) => `${Number(montant).toLocaleString("fr-FR").replace(/ /g, " ")} FCFA`;

// Plus petit tarif réellement renseigné, ou null (jamais de prix inventé).
export function tarifMinimum(enseignant) {
  const ids = new Set((enseignant?.subjects || []).map((s) => String(s.id)));
  const tarifs = Object.entries(enseignant?.hourly_rates || {})
    .filter(([id, v]) => ids.has(String(id)) && Number(v) > 0).map(([, v]) => Number(v));
  return tarifs.length ? Math.min(...tarifs) : null;
}

export const libelleModalites = (modalites) => (modalites || []).map((m) => LIBELLE_MODALITE[m] || m);

// {"lundi": "18h30-20h"} → [["Lundi", "18h30 – 20h"], …] dans l'ordre de la semaine.
export const disponibilitesLisibles = (dispo) => JOURS
  .filter(([cle]) => dispo?.[cle])
  .map(([cle, nom]) => [nom, String(dispo[cle]).replace("-", " – ")]);

export const lieuEnseignant = (e) => [e?.city, e?.zone].filter(Boolean).join(" · ");
export const structureEnseignant = (e) => (e?.independent ? "Intervenant indépendant" : (e?.establishment || ""));
